import { useTranslation } from "react-i18next";
import { ConfirmationModal } from "../../components/ConfirmationModal";
import { FrequencyFormModel } from "../../models/FollowUp";
import { TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface Props {
    info: {
        show: boolean;
        followUp?: FrequencyFormModel;
    };
    onClose: () => void;
    deleteAutomation: (followUp: FrequencyFormModel) => void
}

export const DeleteFrequencyAutomationModal: React.FC<Props> = ({
    info,
    onClose,
    deleteAutomation
}) => {

    const { t } = useTranslation();

    const onDeleteAutomation = () => {
        deleteAutomation(info.followUp!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("DELETE_AUTOMATION")}
            isDeleteConfirm={true}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("DELETE"), icon: <TrashIcon />, onClick: onDeleteAutomation }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('DELETE_AUTOMATION_MESSAGE')}
                </label>
            </div>
        </ConfirmationModal>
    )
}